// extracted by mini-css-extract-plugin
export default {"lazy":"_2FC97Nq","show":"_2q4fCfJ"};